import React from "react";

const headers = ["Size", "Chest", "Front Length", "Across Shoulder"];
const rows = [
  ["S", "105 | 41.5", "73.7 | 29.1", "43.8 | 17.3"],
  ["M", "110 | 43.5", "74.9 | 29.5", "45.7 | 18.1"],
  ["L", "116 | 45.5", "76.2 | 30.1", "47.6 | 18.8"],
  ["XL", "121 | 47.5", "78.2 | 30.8", "49.5 | 19.5"],
  ["2XL", "126 | 49.5", "78.7 | 31.1", "51.4 | 20.3"],
];

const guide = [
  ["Neck to Shoulder", "Measure from the middle of the neck to the end of the shoulder (where the sleeve starts)."],
  ["Sleeve Length (A)", "Measure from the center back of the collar to the end of the shoulder."],
  ["Sleeve Length (B)", "Measure from the shoulder to the wrist."],
  ["Shoulder to Shoulder", "Measure across from one shoulder to the other."],
  ["Chest", "Measure around the fullest part, keeping the tape flat across the back and close under the arms."],
  ["Front Length", "Measure from the highest point of the shoulder to the desired hemline."],
];

const SizeChartTop = () => {
  return (
    <div className="bg-white p-6 sm:p-8">
      <div className="text-center">
        <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[#b28585]">
          Size Guide
        </p>
        <h2 className="font-display text-3xl font-bold text-[#511d00]">
          Men's Top Wear
        </h2>
        <p className="mt-1 text-xs text-[#8a7575]">All measurements in CM | INCHES</p>
      </div>

      {/* table */}
      <div className="mx-auto mt-6 max-w-2xl overflow-hidden rounded-xl border border-[#eadcc0]">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-[#5e3e3e] text-[#f1e7da]">
              {headers.map((h) => (
                <th key={h} className="px-3 py-3 text-left text-xs font-semibold uppercase tracking-wide">
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={r[0]} className={i % 2 ? "bg-[#fffdf8]" : "bg-white"}>
                {r.map((c, j) => (
                  <td
                    key={j}
                    className={`px-3 py-2.5 ${j === 0 ? "font-bold text-[#511d00]" : "text-[#5e3e3e]"}`}
                  >
                    {c}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* diagram */}
      <div className="mx-auto mt-6 max-w-md overflow-hidden rounded-xl border border-[#eadcc0] bg-[#fffdf8] p-3">
        <img src="https://cdn.kiwisizing.com/shop-8e4b-aacdfe3d0878-1602843231913.png" alt="size chart" className="mx-auto" />
      </div>

      {/* guide */}
      <div className="mx-auto mt-6 max-w-2xl">
        <h3 className="mb-3 font-semibold text-[#511d00]">How to Measure</h3>
        <ul className="space-y-2.5 text-sm leading-relaxed text-[#5e3e3e]">
          {guide.map(([label, text]) => (
            <li key={label}>
              <span className="font-semibold text-[#511d00]">{label}: </span>
              {text}
            </li>
          ))}
        </ul>
        <p className="mt-4 text-xs italic text-[#8a7575]">
          Sizes can vary by 2–3 cm as each piece is measured by hand (1 inch =
          2.54 cm). The size on the label may differ slightly from the one
          ordered.
        </p>
      </div>
    </div>
  );
};

export default SizeChartTop;
